export default __webpack_public_path__ + "static/media/Person To Draw Sound.8613f8fe.mp3";